import firebase from "firebase";

var app = firebase.initializeApp({
  apiKey: "AIzaSyBPJy_GABGW26ZOio0bnf4S7TDgl8bIzRQ",
  authDomain: "volcano-102a9.firebaseapp.com",
  projectId: "volcano-102a9",
  storageBucket: "volcano-102a9.appspot.com",
  messagingSenderId: "498242042339",
  appId: "1:498242042339:web:e031b529c589a4be0e88d6",
  measurementId: "G-HLP21CMS0H",
});
var db = app.firestore();
export { db };
